import { ConsentChangedEventObjectType } from '../../../types/oneTrust';
import { ConsentManager } from './consentManager';
import { oneTrustIsInitialized } from './isInitialized';

export const subscribeToConsentChanged = () => {
    if (oneTrustIsInitialized()) {
        window.OneTrust.OnConsentChanged((e: ConsentChangedEventObjectType) => {
            ConsentManager.notifyCallbacks(e);
        });
    }
};
